import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import SelectedFilters from "./selectedfilters.js";
import { prodListValues } from './shared.js';

const quantityText = document.getElementById('txtProductQuantity');
const submit = document.getElementById('submitProductQuantity');

class ProductQuantityFilter {
    events() {
        if (submit && quantityText) {
            submit.addEventListener('click', (e) => {
                e.preventDefault();
                var productQuantity = quantityText.value;

                if (productQuantity.length === 0) {
                    this.clear();
                    UpdateFilterUrl.update(FilterValues, prodListValues, false);
                } else {
                    this.add(true);
                    UpdateFilterUrl.update(FilterValues, prodListValues, false);
                }
            });

            quantityText.addEventListener('keydown', (e) => {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    submit.click();
                }
            });
        }
    };

    add(logFilter) {
        var filterName = document.getElementById('ProductQuantityFilterTitle').value.replace('##productquantity##', quantityText.value);

        SelectedFilters.removeFromSelectedFilter(quantityText);
        FilterValues.addProductQuantityFilter(quantityText.id, quantityText.value, logFilter);
        quantityText.value = '';
        SelectedFilters.addToSelectedFilter(quantityText, filterName);
    };

    update(term) {
        quantityText.value = term;
        this.add(true);
    };

    clear() {
        quantityText.value = '';
        FilterValues.removeProductQuantityFilter();
        SelectedFilters.removeFromSelectedFilter(quantityText);
    };
}

export default new ProductQuantityFilter();